<template>
  <VueHorizontalList
    :items="cobs"
    :options="{
      responsive: [
        { end: 576, size: 1 },
        { start: 576, end: 768, size: 2 },
        { size: 3 },
      ],
    }"
  >
    <template v-slot:default="{ item }">
      <div class="item">
        <Card
          class="animate__animated animate__fadeInUp"
          :data="item"
          :title="item.DESCRIPCIONCOBERTURA"
          :desc="item.DESCRIP"
          :name="item.NOMENCLATURA"
          :deducible="item.DEDUCIBLES.length > 0 ? item.DEDUCIBLES[0].VALOR : 0"
          :suma="item.SUMAS.length > 0 ? item.SUMAS[0].VALOR : 0"
          :cost="
            item.PRIMA === 0 ? item.PRIMA.toString() : formatMoney(item.PRIMA)
          "
          :radio="item.check"
          :orden="item.ORDEN"
          :updateSuma="updateSumaCobertura"
          :prima="item.PRIMA"
        />
      </div>
    </template>
  </VueHorizontalList>
</template>
<script>
import Card from "./Card.vue";
import VueHorizontalList from "vue-horizontal-list";

export default {
  components: {
    Card,
    VueHorizontalList,
  },
  props: {
    cobs: Array,
    formatMoney: Function,
    updateSumaCobertura: Function,
  },
};
</script>
